import { render, staticRenderFns } from "./GiftCouponPop.vue?vue&type=template&id=4e5d2e02&scoped=true"
import script from "./GiftCouponPop.vue?vue&type=script&lang=ts"
export * from "./GiftCouponPop.vue?vue&type=script&lang=ts"
import style0 from "./GiftCouponPop.vue?vue&type=style&index=0&id=4e5d2e02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5d2e02",
  null
  
)

export default component.exports